// 下游客户热力图数据 —— 关键词「酪蛋白」公开信息热力（配合 /downstream-heat 页面）
// 热力值口径（0-100）：热力 = 「酪蛋白」字样频次 × 应用强度修正
//   - 正向表述（如"全系配方均使用酪蛋白酸钠""以酪蛋白为主要原料""胰酪蛋白胨源自酪蛋白"）按足额计入；
//   - 仅出现"无酪蛋白相关产能/不涉及酪蛋白"等负面表述的按弱关联计（10-18），避免字面频次误判；
//   - 依据：企业公开工商 / 专利 / 官网 / 年报 / 环评 / 行业公开资讯（与 companyNetwork.js 同源）。
// mentions：companyNetwork.js 各公司文案中「酪蛋白」字样出现次数（含负面表述，供 tooltip 展示）

export const caseinHeat = [
  { id: 'zhejiang-boduo', heat: 96, mentions: 3, note: '全系植脂末/茶饮配料核心配方均使用酪蛋白酸钠，七大生产基地满产' },
  { id: 'henan-boxin', heat: 92, mentions: 2, note: '核心产线大量使用酪蛋白酸钠，年产能 10 万吨级、3 万吨技改已投产' },
  { id: 'sichuan-baoshun', heat: 88, mentions: 6, note: '酪蛋白深加工下游：胰酪蛋白胨直接源自酪蛋白，字样频次最高' },
  { id: 'jiangxi-changhui', heat: 84, mentions: 2, note: '官网明确"以植物油、麦芽糖浆、酪蛋白为主要原料"' },
  { id: 'jiangxi-hengding', heat: 80, mentions: 1, note: '植脂末头部（16 万吨/年），稳定酪蛋白原料采购需求' },
  { id: 'guangdong-yuanjian', heat: 76, mentions: 2, note: '植脂末/蛋白固体饮料大量应用酪蛋白酸钠' },
  { id: 'guangdong-duohe', heat: 74, mentions: 2, note: '乳制品/饮品专用蛋白基助剂深度应用酪蛋白原料' },
  { id: 'jiangsu-jiahe', heat: 70, mentions: 1, note: 'A 股粉末油脂头部，持续扩大酪蛋白基高端配料应用场景' },
  { id: 'fujian-bangling', heat: 64, mentions: 1, note: '植脂末核心下游，量产含脂率 20%-70% 全系列' },
  { id: 'jiangsu-lianfeng', heat: 52, mentions: 0, note: '核心蛋白基乳化剂、稳定剂广泛应用乳蛋白原料' },
  { id: 'henan-jinyumi', heat: 48, mentions: 0, note: '乳蛋白改性配料、食品乳化稳定剂规模量产' },
  { id: 'jiangsu-taihe', heat: 18, mentions: 2, note: '公开信息均为"无酪蛋白相关产能"负面表述，弱关联' },
  { id: 'guangdong-maiji', heat: 16, mentions: 1, note: '皮革水性化学品，与食品级酪蛋白应用无关' },
  { id: 'sichuan-jiahe-group', heat: 14, mentions: 6, note: '字样频次高但均为"完全不涉及酪蛋白"负面表述，弱关联' },
  { id: 'zhejiang-ganwei', heat: 12, mentions: 2, note: '橡胶塑料/玩具制造，无酪蛋白相关产品' },
  { id: 'shandong-chunhua', heat: 12, mentions: 4, note: '化工贸易，与酪蛋白应用市场无交集' },
  { id: 'hebei-haoshidai', heat: 10, mentions: 1, note: '乳胶橡胶制品，与食品级酪蛋白无关' },

  // ===== 联网检索补充的酪蛋白 / 酪蛋白酸钠相关下游及行业企业（详见 companyNetwork.js，excludeFromMap 仅入热力图） =====
  { id: 'milkground', heat: 82, mentions: 1, note: '国内奶酪龙头，落地产 MCC 酪蛋白胶束等高附加值乳蛋白产品，奶酪加工大量应用酪蛋白' },
  { id: 'hiroad', heat: 80, mentions: 2, note: '年报明确主要原材料含酪蛋白酸钠（植脂奶油/奶油/蛋白饮料），并布局植物基酪蛋白酸钠替代专利' },
  { id: 'yili', heat: 78, mentions: 1, note: '中国最大乳企，奶酪三期原制马苏里拉投产、首条脱盐乳清粉产线，乳蛋白深加工规模大' },
  { id: 'mengniu', heat: 76, mentions: 1, note: '旗下妙可蓝多原制奶酪规模化，D90 脱盐乳清粉/乳铁蛋白下线，乳清酪蛋白国产替代核心玩家' },
  { id: 'feihe', heat: 72, mentions: 1, note: '婴配粉龙头，赤峰投建二期布局脱盐乳清与酪蛋白生产，乳铁蛋白纯度 95% 以上' },
  { id: 'fonterra', heat: 70, mentions: 2, note: '新西兰最大乳业合作社，全球领先酪蛋白酸盐供应商，康巴圣德国际市场行业对标' },
  { id: 'xiangpiao', heat: 68, mentions: 0, note: '杯装奶茶/即饮乳茶头部，植脂末与含乳蛋白饮品大规模下游用户' },
  { id: 'panda-dairy', heat: 66, mentions: 0, note: '炼乳/奶酪/奶油专业乳企，乳蛋白与奶油类下游应用' },
  { id: 'ligao', heat: 64, mentions: 0, note: '烘焙/冷冻烘焙原料头部，奶油与乳蛋白基配料下游' },
  { id: 'bright-dairy', heat: 62, mentions: 0, note: '华东乳业龙头，低温鲜奶/酸奶/奶酪，乳蛋白稳态化应用' },
  { id: 'newhope-dairy', heat: 58, mentions: 0, note: '西南低温乳业头部，“鲜战略”聚焦鲜奶酸奶，乳蛋白下游' },
  { id: 'byhealth', heat: 58, mentions: 1, note: '膳食营养补充剂龙头，蛋白粉/乳清蛋白为乳基蛋白规模化下游' },
  { id: 'liziyuan', heat: 54, mentions: 0, note: '含乳饮料区域龙头，乳基饮品下游规模化应用' },
  { id: 'namchow', heat: 52, mentions: 0, note: '烘焙油脂/奶油专业供应商，含乳脂奶油与乳蛋白类下游' },
]

// 企业间关联边（同集团 / 同品类 / 同供应链），配合康巴圣德枢纽边构成知识网络
export const heatLinks = [
  // 博多集团（总部-北方基地）
  ['zhejiang-boduo', 'henan-boxin'],
  // 植脂末/茶饮配料品类链
  ['zhejiang-boduo', 'jiangxi-hengding'],
  ['jiangxi-hengding', 'jiangxi-changhui'],
  ['jiangxi-changhui', 'henan-boxin'],
  ['fujian-bangling', 'jiangsu-jiahe'],
  ['fujian-bangling', 'guangdong-yuanjian'],
  ['jiangsu-jiahe', 'jiangxi-hengding'],
  ['guangdong-yuanjian', 'guangdong-duohe'],
  ['guangdong-duohe', 'jiangsu-lianfeng'],
  // 蛋白深加工链
  ['sichuan-baoshun', 'henan-jinyumi'],
  ['henan-jinyumi', 'jiangsu-lianfeng'],
  ['sichuan-baoshun', 'guangdong-duohe'],
  // 同省集群
  ['jiangsu-jiahe', 'jiangsu-taihe'],
  ['jiangsu-taihe', 'jiangsu-lianfeng'],
  ['zhejiang-boduo', 'zhejiang-ganwei'],
  ['guangdong-maiji', 'guangdong-yuanjian'],
  // 新增：乳业龙头关联链
  ['yili', 'mengniu'],
  ['mengniu', 'milkground'],
  ['yili', 'feihe'],
  // 新增：奶油/烘焙/茶饮配料链
  ['hiroad', 'ligao'],
  ['hiroad', 'namchow'],
  ['hiroad', 'xiangpiao'],
  // 新增：含乳饮料/炼乳链
  ['panda-dairy', 'xiangpiao'],
  ['panda-dairy', 'liziyuan'],
  ['byhealth', 'ligao'],
]

export function getHeatById(id) {
  return caseinHeat.find(h => h.id === id) || null
}
